import React from 'react';

function LanguageToggle({ language, onChange, label, english, spanish, inverse = false }) {
  return (
    <div className={`language-toggle ${inverse ? 'language-toggle-inverse' : ''}`} aria-label={label}>
      <button
        type="button"
        className={language === 'en' ? 'active' : ''}
        onClick={() => onChange('en')}
        aria-pressed={language === 'en'}
      >
        {english}
      </button>
      <span aria-hidden="true">|</span>
      <button
        type="button"
        className={language === 'es' ? 'active' : ''}
        onClick={() => onChange('es')}
        aria-pressed={language === 'es'}
      >
        {spanish}
      </button>
    </div>
  );
}

export default LanguageToggle;